module.exports = __webpack_public_path__ + "static/img/aboutTop1-05.0620433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutTop1-05.png
// module id = Ca0m
// module chunks = 1